import React, { useState } from "react";
import { Popover, Typography, Grid, useTheme } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { State } from "./interfaces";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";

const EmailIsNotValid = () => {
  const theme = useTheme();

  const [state, setState] = useState<State>({
    open: false,
    anchorEl: null,
  });

  return (
    <>
      <Grid
        onMouseEnter={(event) => {
          event.stopPropagation();
          setState({
            anchorEl: event.currentTarget,
            open: true,
          });
        }}
        onMouseLeave={(event) => {
          event.stopPropagation();
          setState((state) => ({
            ...state,
            open: false,
          }));
        }}
        sx={{ marginLeft: "5px" }}
      >
        <FontAwesomeIcon
          color={theme.palette.warning.main}
          icon={faExclamationTriangle}
        />
      </Grid>

      <Popover
        open={state.open}
        anchorEl={state.anchorEl}
        anchorOrigin={{ horizontal: "right", vertical: "center" }}
        sx={{
          pointerEvents: "none",
        }}
        PaperProps={{
          sx: {
            padding: "10px",
            width: "450",
          },
        }}
        disableRestoreFocus
      >
        <Grid>
          <Typography sx={{ color: theme.palette.error.main }}>Email is not valid</Typography>
        </Grid>
      </Popover>
    </>
  );
};
export default EmailIsNotValid;
